import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders, FileUploaderOptions } from 'ng2-file-upload';
import { AppSettings, AuthService } from '../../core';

@Component({
	selector: 'sm-upload-file',
	template: require('./sm-upload-file.component.html')
})
export class SmUploadFileComponent implements OnInit {
	@Input() path: string;
	@Input() disabled: boolean;
	@Input() accept: string = '*/*';
	@Input() maxFiles: number;
	@Input() maxFileSize: number;
	@Output() onBeginUploading: EventEmitter<any> = new EventEmitter();
	@Output() onUploaded: EventEmitter<any> = new EventEmitter();
	@Output() onWhenAddingFileFailed: EventEmitter<any> = new EventEmitter();
	uploader: FileUploader;

	private _options: FileUploaderOptions;

	constructor(private _authService: AuthService) { }

	ngOnInit() {
		this._options = {
			url: AppSettings.API_ENDPOINT + this.path,
			authToken: 'Bearer ' + this._authService.getToken(),
			authTokenHeader: 'Authorization',
			maxFileSize: this.maxFileSize// ,
			// queueLimit: this.maxFiles
		};

		this.uploader = new FileUploader(this._options);

		// this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
		// 	console.warn("onErrorItem", item, response, status, headers);
		// 	return { item, response, status, headers };
		// };

		// this.uploader.onAfterAddingAll = (fileItems: any): any => {
		// 	console.warn('onAfterAddingAll', fileItems);
		// 	return {fileItems };
		// }

		// this.uploader.onBuildItemForm = (fileItem: FileItem, form: any): any => {
		// 	console.warn('onBuildItemForm', fileItem, form);
		// 	return { fileItem, form };
		// }

		// this.uploader.onAfterAddingFile = (fileItem: FileItem): any => {
		// 	console.warn('onAfterAddingFile', fileItem);
		// 	return { fileItem };
		// }

		this.uploader.onWhenAddingFileFailed = (item: any, filter: any, options: any): any => {
			let res = { item, filter, options };

			this.uploader.progress = 0;
			this.uploader.isUploading = false;

			this.onWhenAddingFileFailed.emit(res);

			// console.warn(res);

			return res;
		};

		// this.uploader.onBeforeUploadItem = (fileItem: FileItem): any => {
		// 	console.warn('onBeforeUploadItem', fileItem);
		// 	return { fileItem };
		// }

		// this.uploader.onProgressItem = (fileItem: FileItem, progress: any ): any => {
		// 	console.warn('onProgressItem', fileItem, progress);
		// 	return { fileItem, progress };
		// }

		// this.uploader.onProgressAll = (progress: any): any => {
		// 	console.warn('onProgressAll', progress);
		// 	return { progress };
		// }

		// this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
		// 	console.warn('onSuccessItem', item, response, status, headers);
		// 	return { item, response, status, headers };
		// }

		this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
			let res = { item, response, status, headers };

			this.uploader.progress = 0;
			this.uploader.isUploading = false;

			this.onWhenAddingFileFailed.emit(res);

			// console.warn(res);

			return res;
		};

		// this.uploader.onCancelItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
		// 	console.warn('onCancelItem', item, response, status, headers);
		// 	return { item, response, status, headers };
		// }

		// this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
		// 	console.warn('onCompleteItem', item, response, status, headers);
		// 	return { item, response, status, headers };
		// }

		// this.uploader.onCompleteAll = (): any => {
		// 	console.warn('onCompleteAll');
		// 	return void 0;
		// }
	}

	filesSelected() {
		this.onBeginUploading.emit(true);

		let responses: any[] = [];

		// this._options.queueLimit = this.maxFiles;
		this._options.maxFileSize = this.maxFileSize;

		this.uploader.setOptions(this._options);

		this.uploader.onCompleteItem = (item: FileItem, response: string, status: number): any => {

			if (status == 400) {
				return;
			}

			responses.push(JSON.parse(response));
		};

		this.uploader.onCompleteAll = () => {
			this.onUploaded.emit(responses);
		};

		this.uploader.uploadAll();
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-upload-file.component.ts